'use strict';

import $ from 'jquery';
import BaseEntryPoint from 'ofs/apps/core/entry';
import Carousel from './Carousel';
import tracker from 'ofs/utils/Tracker/Tracker';

function displayHeaderSearch($headerSearch, width) {
  if (width > 640) {
    $headerSearch
      .addClass('ofs-HeaderSearch--is-visible')
      .data('open', true);
  } else {
    $headerSearch
      .removeClass('ofs-HeaderSearch--is-visible')
      .data('open', false);
  }
}

export default class EntryPoint extends BaseEntryPoint {
  renderToDocument(document) {
    var carousel;

    super.renderToDocument(document);
    tracker.homePageView();

    function initCarousel() {
      if ($(window).width() > 480) {
        if (!carousel) {
          carousel = new Carousel($('.carousel-container'));
        }
      } else {
        if (carousel) {
          carousel.destroy();
          carousel = null;
        }
      }
    }
    var $headerSearch = $('.ofs-HeaderSearch');

    // determine whether to show header quicksearch on load
    displayHeaderSearch($headerSearch, window.innerWidth);

    window.addEventListener('resize', function(event) {
      var windowWidth = event.target.innerWidth;
      displayHeaderSearch($headerSearch, windowWidth);
      initCarousel();
    });

    initCarousel();
  }
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/homepage/entry.jsx
 **/